import { fmtDate, formatPrice, formatQuantity, formatSignedCurrency } from "@/lib/format";
import { useLanguage } from "@/context/LanguageContext";

const Line = ({ label, children }) => (
  <>
    <span className="text-[#8A97AD]">{label}</span>
    <span className="text-right text-[#C7D0DE]">{children}</span>
  </>
);

const PositionCard = ({ position, tab, onClose, tr }) => {
  const pnl = tab === "closed" ? position.realized_pnl : position.pnl;
  return (
    <div data-testid={`position-card-${position.symbol}`}
         className="rounded-md border border-[#141A26] bg-[#0D1420] p-4">
      <div className="flex items-center justify-between">
        <span className="font-mono text-sm text-white">{position.symbol}</span>
        <span className={`font-mono text-xs uppercase ${position.side === "buy" ? "text-[#10B981]" : "text-[#EF4444]"}`}>
          {String(position.side || "").toUpperCase()}
        </span>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-y-2 font-mono text-xs">
        <Line label={tr("positions.volume")}>{formatQuantity(position.quantity)}</Line>
        <Line label={tr("positions.entry")}>{formatPrice(position.entry_price)}</Line>
        <Line label={tab === "closed" ? tr("positions.close") : tr("positions.current")}>
          {formatPrice(tab === "closed" ? position.close_price : position.current_price)}
        </Line>
        {tab === "open" ? (
          <Line label="TP / SL">
            {position.take_profit ? formatPrice(position.take_profit) : "—"} /{" "}
            {position.stop_loss ? formatPrice(position.stop_loss) : "—"}
          </Line>
        ) : null}
        {tab === "closed" ? (
          <Line label={tr("positions.closedAt")}>{fmtDate(position.closed_at)}</Line>
        ) : null}
        <span className="text-[#8A97AD]">P/L</span>
        <span className={`text-right ${pnl >= 0 ? "text-[#10B981]" : "text-[#EF4444]"}`}>
          {formatSignedCurrency(pnl)}
        </span>
      </div>
      {tab === "open" ? (
        <button onClick={() => onClose(position)} data-testid={`close-position-mobile-${position.symbol}`}
                className="mt-4 w-full rounded-md border border-[#2563EB]/60 bg-[#2563EB]/10 py-3 text-sm font-semibold uppercase tracking-[0.15em] text-[#60A5FA] transition-colors hover:bg-[#2563EB]/20 hover:text-white">
          {tr("positions.closeBtn")}
        </button>
      ) : null}
    </div>
  );
};

export const PositionCards = ({ rows, tab, onClose }) => {
  const { t: tr } = useLanguage();
  return (
    <div className="space-y-3 md:hidden" data-testid="positions-cards">
      {rows.map((p) => (
        <PositionCard key={p.id} position={p} tab={tab} onClose={onClose} tr={tr} />
      ))}
    </div>
  );
};
